export const MODAL_ACTION_TYPE = {
    ADD: 'add',
    EDIT: 'edit'
};
